import useCheckoutThreshold from '../order/useCheckoutThreshold';
import useDeliveryThreshold from '../order/useDeliveryThreshold';
import useOrderMethodsStatus from '../availability/useOrderMethodsStatus';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { ORDER_METHODS } from '../../services/exports/Constants';

const useIsCheckoutDisabled = (): boolean => {
  const { hasReachedCheckoutThreshold } = useCheckoutThreshold();
  const { hasDeliveryThreshold, isWithinThreshold } = useDeliveryThreshold();
  const { isOrderMethodCurrentlyOpen, isOrderMethodOpenForFutureOrders } = useOrderMethodsStatus();
  const cachedOrder = useSelector((state: StoreInterface) => state.order.cached_order);

  // Table orders are as soon as possible only: no ordering for later while the restaurant is closed.
  const canOrderLater =
    cachedOrder?.method !== ORDER_METHODS.ON_SITE && isOrderMethodOpenForFutureOrders(cachedOrder?.method);

  return (
    !hasReachedCheckoutThreshold ||
    (hasDeliveryThreshold && !isWithinThreshold) ||
    (!isOrderMethodCurrentlyOpen(cachedOrder?.method) && !canOrderLater)
  );
};

export default useIsCheckoutDisabled;
